import { render, staticRenderFns } from "./BarProgressList.vue?vue&type=template&id=2ade00b4&scoped=true&"
import script from "./BarProgressList.vue?vue&type=script&lang=js&"
export * from "./BarProgressList.vue?vue&type=script&lang=js&"
import style0 from "./BarProgressList.vue?vue&type=style&index=0&id=2ade00b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade00b4",
  null
  
)

export default component.exports